module.exports = __webpack_public_path__ + "img/user.5a127abf.png";